import { z } from 'zod';

/**
 * File Management Schemas
 * File operations, access control, and file-related functionality
 */

// === File Access Control Enums ===

export const FileACLSchema = z.enum(['private', 'public-read', 'public-read-write'], {
  error: "Invalid file ACL. Must be one of: private, public-read, public-read-write"
});

export const FileActionSchema = z.enum(['read', 'write', 'delete'], {
  error: "Invalid file action. Must be one of: read, write, delete"
});

// Export TypeScript types
export type FileACL = z.infer<typeof FileACLSchema>;
export type FileAction = z.infer<typeof FileActionSchema>;